export default __webpack_public_path__ + "static/media/logo-small.11f6e87e.png";